import React from 'react';
import { Snackbar } from '@mui/material';
import { useTranslation } from './LocalizationProvider';
import { snackBarDurationLongMs } from '../util/duration';

const AwaitDialog = ({
  open,
}) => {
  const t = useTranslation();
  return (
    <Snackbar
      open={open}
      autoHideDuration={snackBarDurationLongMs}
      message={t('sharedWait')}
    />
  );
};

export default AwaitDialog;
